var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStartButton = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.457143 0.0746501C0.685714 -0.0248834 1.02857 -0.0248834 1.25714 0.0746501L15.5417 7.24106C15.8857 7.34059 15.8857 7.53966 16 7.63919C16 7.63919 16 7.73873 15.8857 8.03733C15.8857 8.33593 15.6571 8.63453 15.4286 8.73406L1.25714 15.9005C1.14286 16 0.914286 16 0.8 16C0.685714 16 0.571429 16 0.342857 15.9005C0.114286 15.7014 0 15.5023 0 15.2037V0.771384C0 0.472784 0.228572 0.174184 0.457143 0.0746501Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStartButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/start-button.67b398ef2a334d55f303851a4ddac880.svg";